<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        class="mt-3"
      >
        <h4>Dados de Acesso</h4>
        <fieldset class="font-weight-bold text-muted small">
          Informações para acessar o sistema
        </fieldset>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </b-col>
    </b-row>
    <b-row style="height:5rem">
      <b-form-group
        label="Login (E-mail)"
        class="col-md-6"
      >
        <validation-provider
          #default="{ errors }"
          name="Login"
          rules="required|email"
        >
          <b-form-input
            ref="login"
            v-model="value.login"
            :state="(errors.length > 0 || (erroValidacao && erroValidacao.login !== '')) ? false :null"
            @blur="validaLogin()"
          />
          <small class="text-danger">{{ errors[0] || (erroValidacao && erroValidacao.login) }}</small>
        </validation-provider>
      </b-form-group>
      <b-col
        v-if="showSenha"
        cols="6"
      >
        <b-form-group label="Senha">
          <senha-input
            v-model="value.senha"
            :mostrar-senha="false"
            :validacao-direita="true"
            auto-complete-senha="new-password"
            :required="showSenha"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      class="pb-2"
      :style="isCadastroModal ? 'padding-top:0.8rem':''"
    >
      <b-col cols="6" />
      <b-col
        v-if="showSenha"
        cols="6"
      >
        <b-form-checkbox
          v-model="value.alterarSenha"
          size="sm"
          value="true"
          unchecked-value="false"
          class="detail-check-sm"
        >
          Alterar Senha no Próximo Acesso
        </b-form-checkbox>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">

.detail-check-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-sm.input-group-sm .custom-checkbox .custom-control-label::before {
  left: 0px !important;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm .custom-control-label {
  font-size: 0.95rem !important;
}
</style>

<script>

import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'DadosAcesso',
  components: {
    ValidationProvider,
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    validaLogin: {
      type: Function,
      required: true,
    },
    erroValidacao: {
      type: Object,
      default: () => { },
    },
    isCadastroModal: {
      type: Boolean,
      default: false,
    },
    showSenha: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      required,
    }
  },

}
</script>
